import { LotterySchema, RetailUnitSchema } from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export const PubSubLotteryMessageSchema = Type.Object(
  {
    retailUnitId: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
  },
  { $id: 'PubSubLotteryMessageSchema' }
);

export type PubSubLotteryMessageType = Static<typeof PubSubLotteryMessageSchema>;

export const PubSubLotteryDrawMessageSchema = Type.Object(
  {
    retailUnitId: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
    lotteryDrawId: Type.String(),
  },
  { $id: 'PubSubLotteryDrawMessageSchema' }
);

export type PubSubLotteryDrawMessageType = Static<typeof PubSubLotteryDrawMessageSchema>;

export const PubSubDrawSchedulerSchema = Type.Intersect(
  [
    PubSubLotteryMessageSchema,
    Type.Object({
      action: Type.Union([Type.Literal('UPSERT'), Type.Literal('DELETE')]),
    }),
  ],
  { $id: 'PubSubDrawSchedulerSchema' }
);

export type PubSubDrawSchedulerMessageType = Static<typeof PubSubDrawSchedulerSchema>;

export const PubSubHandleWinnersSchema = Type.Object(
  {
    jobType: Type.Union([Type.Literal('INVALIDATE'), Type.Literal('REPLACE'), Type.Literal('ADD')]),
    retailUnitId: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
    lotteryDrawId: Type.String(),
    partyUids: Type.Optional(Type.Array(Type.String())),
    numberOfNewWinners: Type.Optional(Type.Number()),
  },
  {
    $id: 'PubSubHandleWinnersSchema',
    if: {
      properties: {
        jobType: Type.Union([Type.Literal('INVALIDATE'), Type.Literal('REPLACE')]),
      },
    },
    then: {
      required: ['partyUids'],
    },
    else: {
      if: {
        properties: {
          jobType: Type.Literal('ADD'),
        },
      },
      then: {
        required: ['numberOfNewWinners'],
      },
    },
  }
);

export type PubSubHandleWinnersMessageType = Static<typeof PubSubHandleWinnersSchema>;
